import React from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import TextArea from '~/Common-Objects/UI/Forms/TextArea/TextArea'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'

export default function LandingPageSettingSeo({
    landingPage,
    setValue,
    setOptions,
    saveLandingPage = () => {},
    shortCode,
    errors
}) {
    return (
        <Paper className='paper-padding-24' style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <h4>SEO</h4>
            <TextInput
                label='Page Keywords'
                labelSub={`Add words and phrases that describe your landing page. Keywords should be comma separated.`}
                value={landingPage.options?.keywords}
                onChange={(e) => setOptions('keywords', e.target.value)}
            />
            <TextArea
                label='Page Description'
                rows={4}
                value={landingPage.options?.description}
                onChange={(e) => setOptions('description', e.target.value)}
            />

            <div>
                <Button className='button-primary' onClick={() => saveLandingPage()}>
                    Save
                </Button>
            </div>
        </Paper>
    )
}
